import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Frown, Smile } from "lucide-react";
import { useNavigate } from "react-router-dom";

const beforeItems = [
  { label: "50 bank entries/day per junior", value: "" },
  { label: "Hours spent on purchase invoices", value: "" },
  { label: "Seniors: firefighting wrong ledgers and missing bills", value: "" },
  { label: "Late‑night calls from clients about mistakes", value: "" },
];

const afterItems = [
  { label: "250+ bank entries in ~5 minutes, ready for approval", value: "" },
  { label: "Purchase invoices auto‑drafted as Tally vouchers in mins", value: "" },
  { label: "Seniors: focus on review and analysis, not mistakes!", value: "" },
  { label: "Fewer escalations, smoother closes, happier clients", value: "" },
];

const BeforeAfter = () => {
  const navigate = useNavigate();

  const handleJoinWaitlist = () => {
    navigate('/join-waitlist');
  };

  return (
    <section className="section-padding bg-section">
      <div className="container-narrow mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-4">
            AccountsGenie - Before vs After 
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Before Card */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-card rounded-2xl p-8 border border-border card-elevated"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
                <Frown className="w-6 h-6 text-destructive" />
              </div>
              <div>
                <h3 className="font-display text-xl font-semibold text-foreground">Before Genie</h3>
                <p className="text-sm text-muted-foreground">The old way</p>
              </div>
            </div>
            <ul className="space-y-4">
              {beforeItems.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-destructive/60 mt-2 flex-shrink-0" />
                  <span className="text-muted-foreground">{item.label}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* After Card */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-card rounded-2xl p-8 border-2 border-primary/20 card-elevated relative overflow-hidden"
          >
            <div className="absolute top-0 right-0 w-32 h-32 bg-genie-soft rounded-bl-full opacity-50" />
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Smile className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-display text-xl font-semibold text-foreground">With Genie</h3>
                  <p className="text-sm text-muted-foreground">The new way</p>
                </div>
              </div>
              <ul className="space-y-4">
                {afterItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <span className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                    <span className="text-foreground">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-center"
        >
          <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-base font-semibold" onClick={handleJoinWaitlist}>
            See Genie on Your Data
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default BeforeAfter;
